export default defineAppConfig({
  ui: {
    colors: {
      primary: 'yellow',
      // neutral: 'slate'
    },
    input: {
      slots: {
        // root: 'relative inline-flex items-center w-full has:[&>input]:aria-[invalid=true]:bg-error-400',
        // base: 'w-full rounded-[calc(var(--ui-radius)*1.5)] border-0 placeholder:text-(--ui-text-dimmed) focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 transition-colors [',
        // leadingIcon: `shrink-0 text-(--ui-text-dimmed)`,
        root: 'relative inline-flex items-center w-full',
        base: 'w-full rounded-[calc(var(--ui-radius)*1.5)] border-0 placeholder:text-(--ui-text-dimmed) focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 transition-colors peer empty:not-active',
        leading: 'absolute inset-y-0 start-0 flex items-center peer-aria-[invalid=true]:[&>span]:bg-error-500 peer-aria-[invalid=false]:[&>span]:bg-success-600 peer-placeholder-shown:[&>span]:!bg-(--ui-text-dimmed)',
      },
      variants: {
        size: {
          xs: {
            base: 'px-2 py-1 text-xs gap-1',
            leading: 'ps-2',
            trailing: 'pe-2',
            leadingIcon: 'size-4',
            leadingAvatarSize: '3xs',
            trailingIcon: 'size-4',
          },
          sm: {
            base: 'px-2.5 py-1.5 text-sm gap-1.5',
            leading: 'ps-2.5',
            trailing: 'pe-2.5',
            leadingIcon: 'size-5',
            leadingAvatarSize: '2xs',
            trailingIcon: 'size-5',
          },
          md: {
            base: 'px-3 py-2 text-md gap-2',
            leading: 'ps-3',
            trailing: 'pe-3',
            leadingIcon: 'size-6',
            leadingAvatarSize: 'xs',
            trailingIcon: 'size-6',
          },
          lg: {
            base: 'px-3.5 py-2.5 text-lg gap-2.5',
            leading: 'ps-3',
            trailing: 'pe-3',
            leadingIcon: 'size-7',
            leadingAvatarSize: 'md',
            trailingIcon: 'size-7',
          },
          xl: {
            base: 'px-4 py-3 text-xl gap-3',
            leading: 'ps-3',
            trailing: 'pe-3',
            leadingIcon: 'size-6',
            leadingAvatarSize: 'lg',
            trailingIcon: 'size-6',
          },
        },
      },
    },
    switch: {
      slots: {
        // root: 'relative flex items-start coursor-pointer',
        // container: 'flex items-center coursor-pointer',
        base: 'inline-flex items-center shrink-0 rounded-full border-2 border-transparent focus-visible:outline-2 focus-visible:outline-offset-2 data-[state=unchecked]:bg-(--ui-bg-accented) transition-colors duration-200 !coursor-pointer',
        label: 'block font-medium text-(--ui-text) !coursor-pointer',
      },
    },
    modal: {
      slots: {
        title: 'text-(--ui-text-highlighted) font-semibold text-2xl',
        description: 'mt-1 text-(--ui-text-muted) text-sm',
      },
    },
    radioGroup: {
      slots: {
        // root: 'relative',
        // fieldset: 'flex',
        // legend: 'mb-1 block font-medium text-(--ui-text)',
        item: 'flex items-start rounded-sm border-2 border-neutral-200 py-4 px-6 has-[&>button[data-active=false]]:[&_p]:hidden has-[&>button[data-active=true]]:border-primary-500 bg-white coursor-pointer',
        // base: 'rounded-full ring ring-inset ring-(--ui-border-accented) focus-visible:outline-2 focus-visible:outline-offset-2',
        // indicator: 'flex items-center justify-center size-full rounded-full after:bg-(--ui-bg) after:rounded-full',
        container: 'flex items-center my-auto',
        wrapper: 'ms-2 w-full text-start',
        label: 'block font-semibold text-(--ui-text) w-full text-start coursor-pointer',
        // description: 'text-(--ui-text-muted)',
      },
    },
    button: {
      slots: {
        base: 'rounded-[calc(var(--ui-radius)*1.5)] font-medium inline-flex items-center focus:outline-hidden disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75 transition-colors cursor-pointer',
        // label: 'truncate',
        // leadingIcon: 'shrink-0',
        // leadingAvatar: 'shrink-0',
        // leadingAvatarSize: '',
        // trailingIcon: 'shrink-0'
      },
      variants: {
        color: {
          // primary: '',
          // secondary: '',
          // success: '',
          // info: '',
          // warning: '',
          // error: '',
          // neutral: ''
          inherit: 'text-inherit',
          vipps: 'bg-vipps hover:bg-vipps-hover font-vipps transition text-white px-[24px] max-md:text-[18pt] md:text-[14pt]',
        },
        variant: {
          // solid: '',
          // outline: '',
          // soft: '',
          // subtle: '',
          // ghost: '',
          link: '!p-0 underline hover:no-underline transition',
        },
        size: {
          // inherit: {
          //   base: '',
          //   leadingIcon: 'size-4',
          //   leadingAvatarSize: '3xs',
          //   trailingIcon: 'size-4',
          // },
          xs: {
            base: 'px-2 py-1 text-xs gap-1',
            leadingIcon: 'size-4',
            leadingAvatarSize: '3xs',
            trailingIcon: 'size-4',
          },
          sm: {
            base: 'px-2.5 py-1.5 text-sm gap-1.5',
            leadingIcon: 'size-5',
            leadingAvatarSize: '3sm',
            trailingIcon: 'size-5',
          },
          md: {
            base: 'px-3 py-2 text-md gap-2',
            leadingIcon: 'size-6',
            leadingAvatarSize: '2md',
            trailingIcon: 'size-6',
          },
          lg: {
            base: 'px-3.5 py-2.5 text-lg gap-2.5',
            leadingIcon: 'size-7',
            leadingAvatarSize: 'lg',
            trailingIcon: 'size-7',
          },
          xl: {
            base: 'px-4 py-3 text-xl gap-3',
            leadingIcon: 'size-8',
            leadingAvatarSize: 'xl',
            trailingIcon: 'size-8',
          },
        },
      },
      defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'md',
      },
    },
    alert: {
      defaultVariants: {
        color: 'neutral',
        variant: 'subtle',
        size: 'md',
      },
    },
    accordion: {
      slots: {
        trigger: 'group flex-1 flex items-center gap-1.5 font-medium text-sm py-3.5 focus-visible:outline-(--ui-primary) min-w-0 cursor-pointer',
      },
    },
  },
})
